<script>
export default {
    name: "RegistrationReportPrint",

    data() {

        return {
            patients: [],
        };
    },

    mounted() {
        Promise.allSettled([ this.fetchPatients(), ]).then(() => {
            window.print();
        }).catch(() => {});
    },

    methods: {

        fetchPatients() {

            let url = `PatientsReports/GetPatientRegistrationReport?Page=${this.$route.query.page}&pagesize=${this.$route.query.pageSize}&Datefrom=${this.$route.query.dateFrom}&Dateto=${this.$route.query.dateTo}`;

            return this.$http.get(url).then(response => {
                this.patients = response.data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="flex flex-wrap">
        <tail-address-header></tail-address-header>
        <div class="flex-1 text-center my-2">
            <h5 class="font-medium uppercase">Registration Report</h5>
        </div>
        <table class="table mt-2">
            <thead class="text-sm font-medium">
                  <tr class="w-full flex">
                      <th class="p-tiny w-1/12">MRN</th>
                      <th class="p-tiny w-1/6">Names</th>
                      <th class="p-tiny w-1/12">IP No</th>
                      <th class="p-tiny w-1/12">OP No</th>
                      <th class="p-tiny w-1/12">ID No</th>
                      <th class="p-tiny w-1/12">DOB</th>
                      <th class="p-tiny w-1/12">Reg Date</th>
                      <th class="p-tiny w-1/12">CellPhone</th>
                      <th class="p-tiny w-1/12">Visits(s)</th>
                      <th class="p-tiny w-1/6">Username</th>
                  </tr>
            </thead>
            <tbody class="text-xs flex flex-col items-center">
                <tr class="w-full flex" v-for="(patient, idx) in patients" :key="idx">
                    <td class="p-tiny w-1/12">{{ patient.patienT_ID }}</td>
                    <td class="p-tiny w-1/6">{{ patient.names }}</td>
                    <td class="p-tiny w-1/12">{{ patient.ipfileno }}</td>
                    <td class="p-tiny w-1/12">{{ patient.opfileno }}</td>
                    <td class="p-tiny w-1/12">{{ patient.nationalid }}</td>
                    <td class="p-tiny w-1/12">{{ patient.dob | dateFormat }}</td>
                    <td class="p-tiny w-1/12">{{ patient.regdate | dateFormat }}</td>
                    <td class="p-tiny w-1/12">{{ patient.celL_PHONE }}</td>
                    <td class="p-tiny w-1/12">{{ patient.visitCount }}</td>
                    <td class="p-tiny w-1/6">{{ patient.username }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>